if (!window.vf) {
    window.vf = {};
}

vf['page-condition-checker'] = (function (vf) {
    'use strict';
    var defaultConfig = {
        forLayout: 'desktop'
    };
    var url = window.location.pathname;


    function setUrl(newUrl) {
        url = newUrl;
    }

    function glob(pattern, input) {
        var re = new RegExp(pattern.replace(/([.?+^$[\]\\(){}|\/-])/g, '\\$1').replace(/\*/g, '.*'));
        return re.test(input);
    }

    function getCurrentLayout() {
        var layout = vf.util.layout(true);
        if(layout) {
            return layout;
        }

        if (1024 <= screen.width) {
            return 'desktop';
        }
        if (600 <= screen.width) {
            return 'tablet';
        }
        return 'mobile';
    }

    function isCorrectLayout(configLayout) {
        var layouts = ['mobile', 'tablet', 'desktop'];
        if (!configLayout) {
            return true;
        }
        var layArr = configLayout.split(' ');
        switch (layArr[0]) {
        case '>=':
            return layouts.indexOf(getCurrentLayout()) >= layouts.indexOf(layArr[1]);
            break;
        case '<=':
            return layouts.indexOf(getCurrentLayout()) <= layouts.indexOf(layArr[1]);
            break;
        }
        return -1 < layArr.indexOf(getCurrentLayout());
    }


    function loadConfig(loadUrl) {
        var promise = $.Deferred();

        $.ajax({
            'url': loadUrl || '/simplicity/ajax/json/enterprise/globalcomponents/testconditions.json'
        }).done(function (data) {
            promise.resolve(data);
        }).fail(promise.reject);

        return promise;
    }

    function doesMatch(config) {
        var sites = ('string' === (typeof config.sites)) ? [config.sites] : config.sites || [];
        for (var i = 0; i < sites.length; i++) {
            if (glob(sites[i], url)) {
                return true;
            }
        }
        return false;
    }

    function doesMatchBlacklist(config) {
        var sites = ('string' === (typeof config.blacklist)) ? [config.blacklist] : config.blacklist || [];
        for (var i = 0; i < sites.length; i++) {
            if (glob(sites[i], url)) {
                return true;
            }
        }
        return false;
    }

    function mergeTypeConfig(config) {
        if (!config.type || 'string' !== (typeof config.type)) {
            return $.extend(true, {}, defaultConfig, config);
        }
        var objArr = config.type.split('.');
        objArr.push('conditionconfig');
        var currObj = window;
        for (var i = 0; i < objArr.length; i++) {
            var key = objArr[i];
            if (currObj[key] && (i + 1) === objArr.length) {
                return $.extend(true, {}, defaultConfig, currObj[key](config), config);
            } else if (currObj[key]) {
                currObj = currObj[key];
            } else {
                return config;
            }
        }
        return null;
    }

    function parseConfig(conditionConfig) {
        for (var key in conditionConfig) {
            var currentConfig = mergeTypeConfig(conditionConfig[key]);
            if (doesMatch(currentConfig) && !doesMatchBlacklist(currentConfig) && isCorrectLayout(currentConfig.forLayout)) {
                return currentConfig;
                break;
            }
        }
        return null;
    }


    function init(loadUrl) {

        var promise = $.Deferred();

        loadConfig(loadUrl).then(function (conditionConfig) {
            var config = parseConfig(conditionConfig);
            promise.resolve(config);
        }).fail(promise.reject);
        return promise;
    }


    return {
        setUrl: setUrl,
        init: init
    };
})(vf);
